<template>
  <article :class="['news']">
    <!-- <child-page-header
    :titleText='titleText'
    :showGoBack="showGoBack"
    ></child-page-header> -->
    
    <section class="news-container" v-html="news"></section>

  </article>
</template>

<script>

  import Header from '@/components/child-components/Header'
  import Footer from './child-components/Footer'

  export default {
    name:"news-page",
    data(){
      return {
        titleText:"最新消息",
        showGoBack:true,
        news:"",
      }
    },
    components:{
      "child-page-header":Header,
      "news-footer":Footer,
    },
		methods:{


			getNewsInfo(){
        this.$http.get("https://www.callmefix.net/api/scopegoods/getScopeInfoGoodsList", {
          params: {
            infoid: 4
          },
        }).then((sucRes) => {
          var res = sucRes.body;
          for(var i=0;i<res.data.length;i++){
            if(res.data[i].ID==92){
              this.news = res.data[i].ScopeContent;
              break;
            }
          }
        })
      }
		},
    created() {
      this.getNewsInfo();
    }
  }
</script>

<style scoped="scoped" lang="less">
  @import '../style/variable';

  .news-container{
    flex: 1;
    .overfA();
    padding: @headerPaddingLr;
  }

</style>



// WEBPACK FOOTER //
// src/components/News.vue